module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-04-3cc6b958e52815ca1228d448caa346c4.png";